import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const GoogleCalendarActions = {
  async authorizeGoogleCalendar () {
    return axiosRequest.
      patch('/users/google_calendar/authorize').
      then(({ data }) => location.replace(data)).
      catch(handleError)
  },

  async deauthorizeGoogleCalendar ({ commit, dispatch }) {
    return axiosRequest.
      delete('/users/google_calendar/deauthorize').
      then(({ data }) => {
        commit('setCurrentUser', data.user, { root: true })
        dispatch('refreshGoogleCalendarInfo')
      }).
      catch(handleError)
  },

  async refreshGoogleCalendarInfo ({ commit }) {
    return axiosRequest.
      get('/users/google_calendar/info').
      then(({ data }) => commit('setGoogleCalendarInfo', data)).
      catch(handleError)
  },

  async updateGoogleCalendarInfo ({ commit }, data) {
    commit('updateGoogleCalendarInfo', data)
  },

  async createCalendarOnGoogleCalendar ({ commit }) {
    return axiosRequest.
      post('/users/google_calendar/create_calendar').
      then(({ data }) => commit('setGoogleCalendarInfo', data)).
      catch(handleError)
  },

  async resyncGoogleCalendar () {
    return axiosRequest.
      post('/users/google_calendar/resync').
      catch(handleError)
  },
}
